<p-toast></p-toast>
<p-confirmDialog icon="pi pi-exclamation-triangle"></p-confirmDialog>
<habil-grupo>
  <div class="p-grid p-fluid" *ngIf="!carregando">
    <div class="p-col-12">
      <p>
        Envia todos os clientes da central para o Habil Desk, com as licenças, as emissões
        (NF-e, NFC-e, NFS-e e SAT) e o "Atender até" do atendimento. O envio é feito em lotes
        para não sobrecarregar o servidor. Clientes alterados na central já são enviados
        automaticamente ao salvar.
      </p>
    </div>
    <div class="p-col-12" *ngIf="status && !status.configurada">
      <div class="aviso">
        Chave da integração não informada: defina <b>HABIL_DESK_CHAVE</b> no servidor da central
        com o mesmo valor de <b>CENTRAL_CLIENTE_CHAVE</b> do .env do Desk.
      </div>
    </div>
    <div class="p-col-12" *ngIf="status?.inicio">
      <p-progressBar [value]="progresso"></p-progressBar>
    </div>
    <div class="p-col-12" *ngIf="status?.inicio">
      <div class="p-grid resumo">
        <div class="p-col-2"><span>Situação</span><b>{{ status.emAndamento ? 'Enviando...' : 'Concluído' }}</b></div>
        <div class="p-col-2"><span>Processados</span><b>{{ status.processados || 0 }} de {{ status.total || 0 }}</b></div>
        <div class="p-col-2"><span>Criados no Desk</span><b>{{ status.criados || 0 }}</b></div>
        <div class="p-col-2"><span>Atualizados</span><b>{{ status.atualizados || 0 }}</b></div>
        <div class="p-col-2"><span>Erros</span><b>{{ status.erros || 0 }}</b></div>
        <div class="p-col-2">
          <span>Início / fim</span>
          <b>{{ status.inicio | date: 'dd/MM/yyyy HH:mm' }}<ng-container *ngIf="status.fim"> - {{ status.fim | date: 'HH:mm' }}</ng-container></b>
        </div>
        <div class="p-col-12" *ngIf="status.ultimoErro">
          <span>Último erro</span>
          <b class="erro">{{ status.ultimoErro }}</b>
        </div>
      </div>
    </div>
  </div>
</habil-grupo>
<br />
<habil-grupo>
  <div class="p-fluid p-grid">
    <div class="p-col"></div>
    <div class="p-col-3">
      <button
        pButton
        icon="pi pi-send"
        label="Enviar todos os clientes para o Desk"
        [loading]="enviando || status?.emAndamento"
        [disabled]="carregando || !status?.configurada || status?.emAndamento"
        (click)="confirmarEnvio()"
      ></button>
    </div>
  </div>
</habil-grupo>
